export function ChartIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2 9.73317C2 9.35977 2 9.1731 2.07266 9.0305C2.13658 8.90504 2.23857 8.8031 2.36401 8.73917C2.50661 8.6665 2.6933 8.6665 3.06667 8.6665H3.6C3.97337 8.6665 4.16005 8.6665 4.30266 8.73917C4.4281 8.8031 4.53009 8.90504 4.59401 9.0305C4.66667 9.1731 4.66667 9.35977 4.66667 9.73317V12.9332C4.66667 13.3066 4.66667 13.4932 4.59401 13.6358C4.53009 13.7613 4.4281 13.8632 4.30266 13.9272C4.16005 13.9998 3.97337 13.9998 3.6 13.9998H3.06667C2.6933 13.9998 2.50661 13.9998 2.36401 13.9272C2.23857 13.8632 2.13658 13.7613 2.07266 13.6358C2 13.4932 2 13.3066 2 12.9332V9.73317Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.6665 3.06667C6.6665 2.6933 6.6665 2.50661 6.73917 2.36401C6.8031 2.23857 6.90504 2.13658 7.0305 2.07266C7.1731 2 7.35977 2 7.73317 2H8.2665C8.6399 2 8.82657 2 8.96917 2.07266C9.09464 2.13658 9.19657 2.23857 9.2605 2.36401C9.33317 2.50661 9.33317 2.6933 9.33317 3.06667V12.9333C9.33317 13.3067 9.33317 13.4934 9.2605 13.636C9.19657 13.7615 9.09464 13.8634 8.96917 13.9273C8.82657 14 8.6399 14 8.2665 14H7.73317C7.35977 14 7.1731 14 7.0305 13.9273C6.90504 13.8634 6.8031 13.7615 6.73917 13.636C6.6665 13.4934 6.6665 13.3067 6.6665 12.9333V3.06667Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.3335 7.06667C11.3335 6.69327 11.3335 6.50661 11.4062 6.36401C11.4701 6.23857 11.572 6.13658 11.6975 6.07266C11.8401 6 12.0268 6 12.4002 6H12.9335C13.3069 6 13.4936 6 13.6362 6.07266C13.7616 6.13658 13.8636 6.23857 13.9275 6.36401C14.0002 6.50661 14.0002 6.69327 14.0002 7.06667V12.9333C14.0002 13.3067 14.0002 13.4934 13.9275 13.636C13.8636 13.7615 13.7616 13.8634 13.6362 13.9273C13.4936 14 13.3069 14 12.9335 14H12.4002C12.0268 14 11.8401 14 11.6975 13.9273C11.572 13.8634 11.4701 13.7615 11.4062 13.636C11.3335 13.4934 11.3335 13.3067 11.3335 12.9333V7.06667Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
